export const Hivewatch = ({
  className,
  color = 'currentColor',
}: {
  className?: string
  color?: string
}) => {
  return (
    <svg
      className={className}
      fill='none'
      viewBox='0 0 20 20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.5138 13.4738L4.5138 7.10552L10 3.92055L15.4845 7.10382L15.4845 13.4729L10 16.6587L4.5138 13.4738ZM10 1L2 5.6461L2 14.934L10 19.5801L18 14.934L16.8185 14.2491L16.8185 6.33188L10 2.37242V1Z'
        fill={color}
      ></path>
      <path
        d='M10.0001 6.11607V4.74365L5.22314 7.51579L5.22314 13.0618L10.0001 15.8339L14.7754 13.0618L13.5939 12.3751L13.5939 8.20072L10.0001 6.11437V6.11607ZM12.2608 11.6023L9.99928 12.9151L7.73779 11.6023L7.73779 8.97606L9.99928 7.6625L12.2608 8.97606L12.2608 11.6023Z'
        fill={color}
      ></path>
      <path
        d='M10 8.48737L8.44775 9.38895V11.1921L10 12.092L11.5523 11.1921L10 10.2897V8.48737Z'
        fill={color}
      ></path>
    </svg>
  )
}
